import React, {Component} from "react";
import {connect} from "react-redux";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import * as Yup from "yup";
import Form from "../../../../../utils/forms/components/Form";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {authStoreSelectors} from "../../../store/store";
import {AuthActionCreators} from "../../../actions/actionCreators";
import {ActionCreator} from "../../../../../actions/actions";
import "./UserCreationPage.component.scss";
import {User} from "../../../reducers/users.reducer";
import _ from "lodash";
import {isSuperUser} from "../../../../../utils/Authorization/authorization";

export enum USER_ACTIONS {
    ADD_USER = "ADD_USER",
    EDIT_USER = "EDIT_USER",
    EDIT_PROFILE = "EDIT_PROFILE"
}

const rolesSelectItems = roles =>
    roles.map((role, key) => {
        return {
            label: (
                <div key={`${key}-${role.value.length}`} className="select-country">
                    <span>{role.label}</span>
                </div>
            ),
            value: role.value
        };
    });

const userCreationFormFields = _.memoize(({subsidiaries, roles}) => {
        let fields = [
            {
                name: "first_name",
                fieldType: "input",
                fieldOptions: {
                    id: "userCreationFirstName",
                    placeholder: "First Name",
                    inputType: "text",
                    label: "First Name"
                },
                formSpacing: false,
                validation: Yup.string()
                    .trim()
                    .required("Field is required.")
                    .max(50, "Max. 50 characters."),
                columnClass: "col-6"
            },
            {
                name: "last_name",
                fieldType: "input",
                fieldOptions: {
                    id: "userCreationLastName",
                    placeholder: "Last Name",
                    inputType: "text",
                    label: "Last Name"
                },
                formSpacing: false,
                validation: Yup.string()
                    .trim()
                    .required("Field is required.")
                    .max(50, "Max. 50 characters."),
                columnClass: "col-6"
            },
            {
                name: "email",
                fieldType: "input",
                fieldOptions: {
                    id: "userCreationEmail",
                    placeholder: "Email",
                    inputType: "text",
                    label: "Email"
                },
                formSpacing: false,
                validation: Yup.string()
                    .trim()
                    .required("Field is required.")
                    .max(50, "Max. 50 characters."),
                columnClass: "col-6"
            },
            {
                name: "subsidiary",
                fieldType: "select",
                fieldOptions: {
                    id: "subsidiary",
                    noValueLabel: "Choose subsidiaries...",
                    label: "Permission for Subsidiaries",
                    items: subsidiaries,
                    multipleSelection: true
                },
                validation: Yup.string().nullable().required("Field is required."),
                columnClass: "col-6"
            },
            {
                name: "roles",
                fieldType: "select",
                fieldOptions: {
                    id: "roles",
                    noValueLabel: "Choose roles...",
                    label: "Roles",
                    items: roles,
                    multipleSelection: true
                },
                columnClass: "col-12"
            }
        ];
        if (isSuperUser()) fields = superAdminFormFields(fields)
        return fields
    }
);

const userProfileFormFields = () => {
    let fields = [{
        name: "first_name",
        fieldType: "input",
        fieldOptions: {
            id: "userCreationFirstName",
            placeholder: "First Name",
            inputType: "text",
            label: "First Name"
        },
        formSpacing: false,
        validation: Yup.string()
            .trim()
            .required("Field is required.")
            .max(50, "Max. 50 characters."),
        columnClass: "col-6"
    },
        {
            name: "last_name",
            fieldType: "input",
            fieldOptions: {
                id: "userCreationLastName",
                placeholder: "Last Name",
                inputType: "text",
                label: "Last Name"
            },
            formSpacing: false,
            validation: Yup.string()
                .trim()
                .required("Field is required.")
                .max(50, "Max. 50 characters."),
            columnClass: "col-6"
        },
        {
            name: "email",
            fieldType: "input",
            fieldOptions: {
                id: "userCreationEmail",
                placeholder: "Email",
                inputType: "text",
                label: "Email"
            },
            formSpacing: false,
            validation: Yup.string()
                .trim()
                .required("Field is required.")
                .max(50, "Max. 50 characters."),
            columnClass: "col-12 fake-double-place"
        }]

    if (isSuperUser()) fields = superAdminFormFields(fields)

    return fields
};

const superAdminFormFields = (fields) => {
    fields.push(
        {
            name: "is_superuser",
            fieldType: "switch",
            fieldOptions: {
                id: "is_superuser",
                placeholder: "",
                inputType: "switch",
                label: "Administrator"
            },
            columnClass: "col-6"
        }
    )

    fields.map(field => {
        if (field.name === "subsidiary") {
            field.validation = Yup.string().when('is_superuser', (isBig, schema) => {
                return isBig ? schema : schema.nullable().required("Field is required.");
            })
        }
        return field
    })

    return fields
}

interface ServerSelectMenuOption {
    value: number | string | boolean;
    label: string;
}

export interface UserCreationProps {
    usersPrivileges: ServerSelectMenuOption[];
    createUser: ActionCreator;
    editUser: ActionCreator;
    subsidiariesLoading: boolean;
    subsidiaries: any;
    filters?: object;
    drawer_values: {
        drawer_title: string;
        user_obj: User;
        form_button_name: string;
        user_action: string;
    };
    users_dict: {
        number_of_total_users: number;
        users: User[];
    };
}

export interface UserCreationState {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    form_button_name: string;
    is_superuser: boolean;
    user_action: any;
    profile_picture: File;
    profile_picture_base64: any;
    profile_picture_file_path: string;
    form_is_valid: boolean;
    subsidiary: any;
    roles: any;
}

class UserCreationPage extends Component<UserCreationProps, UserCreationState> {
    form: React.RefObject<Form>;

    constructor(props) {
        super(props);
        this.form = React.createRef();
        let roles = []
        if (props.drawer_values.user_action !== USER_ACTIONS.EDIT_PROFILE && props.drawer_values.user_obj && props.drawer_values.user_obj.roles) {
            props.drawer_values.user_obj.roles.map(role => {
                role.in.map(i => {
                    this.props.usersPrivileges.map(p => {
                        p['in'].map(f => {
                            if (f.id === i.id)
                                roles.push(p.value)
                        })
                    })
                })
                return roles
            })
        }
        this.state = {
            id: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.id
                : null,
            first_name: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.first_name
                : "",
            last_name: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.last_name
                : "",
            email: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.email
                : "",
            user_action: props.drawer_values.user_action
                ? props.drawer_values.user_action
                : "",
            is_superuser: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.is_superuser
                : false,
            form_button_name: props.drawer_values.form_button_name
                ? props.drawer_values.form_button_name
                : "",
            profile_picture: null,
            profile_picture_base64: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.profile_picture_base64
                : "",
            form_is_valid: false,
            profile_picture_file_path: props.drawer_values.user_obj
                ? props.drawer_values.user_obj.profile_picture
                : "",
            subsidiary: props.drawer_values.user_obj && props.drawer_values.user_obj.subsidiaries
                ? props.drawer_values.user_obj.subsidiaries.map(s => s.id)
                : [],
            roles: roles
        };
        this.onFormChange = this.onFormChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
    }

    handleSwitch(current_value, key) {
        let state_copy = {...this.state};
        state_copy[key] = !current_value;
        this.form.current.state.validation.isValid(state_copy).then(isValid => {
            state_copy['form_is_valid'] = isValid;
        });
        this.setState(state_copy);
    }

    onFormChange(e) {
        let new_state = {...this.state};
        new_state["form_is_valid"] = e.isValid;
        new_state["first_name"] = e.values["first_name"];
        new_state["last_name"] = e.values["last_name"];
        new_state["email"] = e.values["email"];
        new_state["subsidiary"] = e.values["subsidiary"];
        new_state["roles"] = e.values["roles"];
        new_state["is_superuser"] = e.values["is_superuser"];
        if (new_state !== this.state) {
            this.setState(new_state);
        }
    }

    convertBase64intoFile() {
        if (
            this.state.user_action == USER_ACTIONS.EDIT_PROFILE &&
            this.state.profile_picture_base64 &&
            this.state.profile_picture_file_path
        ) {
            const profile_picture_name = this.state.profile_picture_file_path
                .split("/")
                .pop();
            const byteString = atob(this.state.profile_picture_base64);
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i);
            }
            const newBlob = new Blob([ab], {type: "image"});
            return [
                new File([newBlob], profile_picture_name, {type: "image"})
            ];
        }
        return [];
    }

    onFormSubmit() {
        const user_info = {};
        user_info["first_name"] = this.state.first_name;
        user_info["last_name"] = this.state.last_name;
        user_info["email"] = this.state.email;
        user_info["is_superuser"] = this.state.is_superuser == true ? 1 : 0;
        user_info["subsidiary"] = this.state.subsidiary;

        if(this.state.profile_picture){
            user_info["profile_picture"] = this.state.profile_picture;
        }
        if (this.state.user_action !== USER_ACTIONS.EDIT_PROFILE) {
            let roles = []
            this.props.usersPrivileges.map(role => {
                if (this.state.roles.includes(role.value)) {
                    role['in'].map(i => roles.push(i.id))
                }
            })
            user_info["user_roles"] = roles
        }

        if (this.state.user_action == USER_ACTIONS.ADD_USER) {
            user_info["exclude_password"] = 1;
            this.props.createUser({
                user_info: user_info,
                search_json: this.props.filters
            });
        } else if (this.state.user_action == USER_ACTIONS.EDIT_USER) {
            this.props.editUser({
                user_id: this.state.id,
                user_info: user_info,
                search_json: this.props.filters
            });
        } else if (this.state.user_action == USER_ACTIONS.EDIT_PROFILE) {
            this.props.editUser({
                user_id: this.state.id,
                user_info: user_info
            });
        }
    }

    handleFile(e) {
        this.setState({profile_picture: e[0]});
    }

    render() {
        if (
            this.props.subsidiariesLoading &&
            this.state.user_action !== USER_ACTIONS.EDIT_PROFILE
        ) {
            return (
                <div id="create-user">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100}/>
                    </div>
                </div>
            );
        } else if (
            this.props.drawer_values.user_action == USER_ACTIONS.ADD_USER ||
            this.props.drawer_values.user_action == USER_ACTIONS.EDIT_USER ||
            (this.props.drawer_values.user_action ==
                USER_ACTIONS.EDIT_PROFILE &&
                this.state.id != null)
        ) {
            const form =
                this.state.user_action !== USER_ACTIONS.EDIT_PROFILE
                    ? userCreationFormFields({
                        subsidiaries: SubsidiaryUtils.subsidiarySelectItems(
                            this.props.subsidiaries
                        ),
                        roles: rolesSelectItems(
                            this.props.usersPrivileges
                        )
                    })
                    : userProfileFormFields();

            return (
                <div id="create-user">
                    <div className="create-content">
                        <div>
                            {this.state.user_action ==
                                USER_ACTIONS.EDIT_PROFILE && (
                                    <div id="upload" className="row">
                                        <div className="col-12">
                                            <Components.FileBox
                                                displayMessage="Drag and drop profile picture"
                                                multipleFilesAllowed={false}
                                                displayIcon={""}
                                                onFilesChange={this.handleFile}
                                                files={this.convertBase64intoFile()}
                                            />
                                        </div>
                                    </div>
                                )}
                            <div className="form-spacer"/>
                            <Form
                                fields={form}
                                ref={this.form}
                                initialValues={this.state}
                                onChange={this.onFormChange}
                                isConfig={this.props.drawer_values.user_action == USER_ACTIONS.EDIT_USER}
                            />
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        className="red-btn create-btn"
                                        onClick={this.onFormSubmit}
                                        disabled={!this.state.form_is_valid}
                                    >
                                        {this.state.form_button_name}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => ({
    usersPrivileges: authStoreSelectors.usersPrivileges(state),
    subsidiaries: authStoreSelectors.subsidiaries(state),
    subsidiariesLoading: authStoreSelectors.subsidiariesLoading(state),
    users_dict: authStoreSelectors.users_dict(state),
});

const mapDispatchToProps = {
    createUser: AuthActionCreators.createUser,
    editUser: AuthActionCreators.editUser
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCreationPage);
